/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

tinymce.addI18n('id', {
  Redo: 'Ulang',
  Undo: 'Batalkan',
  Cut: 'Potong',
  Copy: 'Salin',
  Paste: 'Rekat',
  'Select all': 'Pilih semua',
  'New document': 'Dokumen baru',
  Ok: 'Ok',
  Cancel: 'Batal',
  'Visual aids': 'Alat bantu visual',
  Bold: 'Tebal',
  Italic: 'Miring',
  Underline: 'Garis bawah',
  Strikethrough: 'Coret',
  Superscript: 'Superskrip',
  Subscript: 'Subskrip',
  'Clear formatting': 'Kosongkan format',
  Remove: 'Hapus',
  'Align left': 'Rata kiri',
  'Align center': 'Rata tengah',
  'Align right': 'Rata kanan',
  'No alignment': 'Tanpa pejajaran',
  Justify: 'Rata penuh',
  'Bullet list': 'Daftar bersimbol',
  'Numbered list': 'Daftar bernomor',
  'Decrease indent': 'Kurangi inden',
  'Increase indent': 'Tambah inden',
  Close: 'Tutup',
  Formats: 'Format',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": 'Browser anda tidak mendukung akses langsung ke papan klip. Silakan gunakan pintasan Ctrl+X/C/V dari keyboard.',
  Headings: 'Kepala',
  'Heading 1': 'Kepala 1',
  'Heading 2': 'Kepala 2',
  'Heading 3': 'Kepala 3',
  'Heading 4': 'Kepala 4',
  'Heading 5': 'Kepala 5',
  'Heading 6': 'Kepala 6',
  Preformatted: 'Praformat',
  Div: 'Div',
  Pre: 'Pre',
  Code: 'Kode',
  Paragraph: 'Paragraf',
  Blockquote: 'Kutipan',
  Inline: 'Baris',
  Blocks: 'Blok',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.': 'Tempel sekarang dalam mode teks biasa. Konten sekarang akan ditempelkan sebagai teks biasa hingga Anda mematikan pilihan ini.',
  Fonts: 'Huruf',
  'Font sizes': 'Ukuran huruf',
  Class: 'Kelas',
  'Browse for an image': 'Jelajahi gambar',
  OR: 'ATAU',
  'Drop an image here': 'Letakkan gambar di sini',
  Upload: 'Unggah',
  'Uploading image': 'Unggah gambar',
  Block: 'Blok',
  Align: 'Sejajarkan',
  Default: 'Bawaan',
  Circle: 'Lingkaran',
  Disc: 'Cakram',
  Square: 'Kotak',
  'Lower Alpha': 'Huruf Kecil',
  'Lower Greek': 'Huruf Kecil Yunani',
  'Lower Roman': 'Huruf Kecil Romawi',
  'Upper Alpha': 'Huruf Besar',
  'Upper Roman': 'Huruf Besar Romawi',
  'Anchor...': 'Jangkar..',
  Anchor: 'Jangkar',
  Name: 'Nama',
  ID: 'ID',
  'ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.': 'ID harus dimulai dengan huruf, lalu diikuti hanya oleh huruf, angka, garis pisah, titik, titik dua, atau garis bawah.',
  'You have unsaved changes are you sure you want to navigate away?': 'Anda memiliki perubahan yang belum disimpan, yakin ingin beralih ?',
  'Restore last draft': 'Pulihkan draf sebelumnya',
  'Special character...': 'Karakter khusus...',
  'Special Character': 'Karakter Khusus',
  'Source code': 'Kode sumber',
  'Insert/Edit code sample': 'Tambah/Edit sampel kode',
  Language: 'Bahasa',
  'Code sample...': 'Sampel kode...',
  'Left to right': 'Kiri ke kanan',
  'Right to left': 'Kanan ke kiri',
  Title: 'Judul',
  Fullscreen: 'Layar penuh',
  Action: 'Tindakan',
  Shortcut: 'Pintasan',
  Help: 'Bantuan',
  Address: 'Alamat',
  'Focus to menubar': 'Fokus ke bilah menu',
  'Focus to toolbar': 'Fokus ke bilah alat',
  'Focus to element path': 'Fokus ke alur elemen',
  'Focus to contextual toolbar': 'Fokus ke bilah alat kontekstual',
  'Insert link (if link plugin activated)': 'Masukan tautan (jika plugin tautan diaktifkan)',
  'Save (if save plugin activated)': 'Simpan (jika plugin simpan diaktifkan)',
  'Find (if searchreplace plugin activated)': 'Cari (jika plugin cari ganti diaktifkan)',
  'Plugins installed ({0}):': 'Plugin terpasang ({0}):',
  'Premium plugins:': 'Plugin premium:',
  'Learn more...': 'Ketahui selengkapnya...',
  'You are using {0}': 'Anda menggunakan {0}',
  Plugins: 'Plugin',
  'Handy Shortcuts': 'Pintasan Bermanfaat',
  'Horizontal line': 'Garis horizontal',
  'Insert/edit image': 'Masukkan/edit gambar',
  'Alternative description': 'Deskripsi alternatif',
  Accessibility: 'Aksesibilitas',
  'Image is decorative': 'Gambar Hiasan',
  Source: 'Sumber',
  Dimensions: 'Dimensi',
  'Constrain proportions': 'Pertahankan proporsi',
  General: 'Umum',
  Advanced: 'Lanjutan',
  Style: 'Gaya',
  'Vertical space': 'Ruang vertikal',
  'Horizontal space': 'Ruang horizontal',
  Border: 'Batas',
  'Insert image': 'Masukkan gambar',
  'Image...': 'Gambar...',
  'Image list': 'Daftar gambar',
  Resize: 'Ubah ukuran',
  'Insert date/time': 'Masukkan tanggal/waktu',
  'Date/time': 'Tanggal/waktu',
  'Insert/edit link': 'Masukkan/edit tautan',
  'Text to display': 'Teks yang akan ditampilkan',
  Url: 'Url',
  'Open link in...': 'Buka tautan dalam...',
  'Current window': 'Jendela saat ini',
  None: 'Tidak ada',
  'New window': 'Jendela baru',
  'Open link': 'Buka tautan',
  'Remove link': 'Hapus tautan',
  Anchors: 'Jangkar',
  'Link...': 'Tautan...',
  'Paste or type a link': 'Rekat atau ketik tautan',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?': 'URL yang dimasukkan sepertinya adalah alamat email. Apakah Anda ingin menambahkan prefiks mailto: yang dibutuhkan?',
  'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?': 'Tautan yang dimasukkan sepertinya adalah tautan eksternal. Apakah Anda ingin menambahkan prefiks http:// yang dibutuhkan?',
  'The URL you entered seems to be an external link. Do you want to add the required https:// prefix?': 'URL yang Anda masukkan tampaknya merupakan tautan eksternal. Apakah Anda ingin menambahkan awalan https:// yang diperlukan?',
  'Link list': 'Daftar tautan',
  'Insert video': 'Masukkan video',
  'Insert/edit video': 'Masukkan/edit video',
  'Insert/edit media': 'Masukkan/edit media',
  'Alternative source': 'Sumber alternatif',
  'Alternative source URL': 'URL Sumber alternatif',
  'Media poster (Image URL)': 'Poster media (URL gambar)',
  'Paste your embed code below:': 'Rekatkan kode sematan di bawah:',
  Embed: 'Semat',
  'Media...': 'Media...',
  'Nonbreaking space': 'Spasi',
  'Page break': 'Halaman baru',
  'Paste as text': 'Rekatkan sebagai teks',
  Preview: 'Pratinjau',
  Print: 'Cetak',
  'Print...': 'Cetak...',
  Save: 'Simpan',
  Find: 'Cari',
  'Replace with': 'Ganti dengan',
  Replace: 'Ganti',
  'Replace all': 'Ganti semua',
  Previous: 'Sebelumnya',
  Next: 'Berikutnya',
  'Find and Replace': 'Temukan dan Ganti',
  'Find and replace...': 'Cari dan ganti...',
  'Could not find the specified string.': 'Tidak dapat menemukan string yang dimaksud.',
  'Match case': 'Samakan besar kecil huruf',
  'Find whole words only': 'Cari hanya kata utuh',
  'Find in selection': 'Cari dari yang dipilih',
  'Insert table': 'Masukkan tabel',
  'Table properties': 'Properti tabel',
  'Delete table': 'Hapus tabel',
  Cell: 'Sel',
  Row: 'Baris',
  Column: 'Kolom',
  'Cell properties': 'Properti sel',
  'Merge cells': 'Gabung sel',
  'Split cell': 'Bagi sel',
  'Insert row before': 'Sisipkan baris sebelum',
  'Insert row after': 'Sisipkan baris setelah',
  'Delete row': 'Hapus baris',
  'Row properties': 'Properti baris',
  'Cut row': 'Potong baris',
  'Cut column': 'Potong kolom',
  'Copy row': 'Salin baris',
  'Copy column': 'Salin kolom',
  'Paste row before': 'Rekat baris sebelum',
  'Paste column before': 'Tempel kolom ke sebelum',
  'Paste row after': 'Rekat baris setelah',
  'Paste column after': 'Tempel kolom ke setelah',
  'Insert column before': 'Masukkan kolom sebelum',
  'Insert column after': 'Masukkan kolom setelah',
  'Delete column': 'Hapus kolom',
  'Cut column': 'Potong kolom',
  'Copy column': 'Salin kolom',
  'Paste column before': 'Tempel kolom sebelum',
  'Paste column after': 'Tempel kolom setelah',
  Cols: 'Kolom',
  Rows: 'Baris',
  Width: 'Lebar',
  Height: 'Tinggi',
  'Cell spacing': 'Jarak sel',
  'Cell padding': 'Lapisan sel',
  'Row clipboard actions': 'Aksi baris clipboard',
  'Column clipboard actions': 'Aksi kolom clipboard',
  'Table styles': 'Corak tabel',
  'Cell styles': 'Corak sel',
  'Column header': 'Kepala kolom',
  'Row header': 'Baris kolom',
  'Table caption': 'Judul tabel',
  Caption: 'Judul',
  'Show caption': 'Perlihatkan keterangan',
  Left: 'Kiri',
  Center: 'Tengah',
  Right: 'Kanan',
  'Cell type': 'Tipe sel',
  Scope: 'Cakupan',
  Alignment: 'Penyejajaran',
  'Horizontal align': 'Sejajar horisontal',
  'Vertical align': 'Sejajar vertikal',
  Top: 'Atas',
  Middle: 'Tengah',
  Bottom: 'Bawah',
  'Header cell': 'Sel judul',
  'Row group': 'Grup baris',
  'Column group': 'Grup kolom',
  'Row type': 'Tipe baris',
  Header: 'Judul',
  Body: 'Badan',
  Footer: 'Catatan kaki',
  'Border color': 'Warna pinggiran',
  Solid: 'Padat',
  Dotted: 'Titik-titik',
  Dashed: 'Garis-garis',
  Double: 'Ganda',
  Groove: 'Tumbuh',
  Ridge: 'Kerut',
  Inset: 'Inset',
  Outset: 'Outset',
  Hidden: 'Sembunyi',
  'Insert template...': 'Masukkan template...',
  Templates: 'Template',
  Template: 'Template',
  'Insert Template': 'Masukkan Template',
  'Text color': 'Warna teks',
  'Background color': 'Warna latar belakang',
  'Custom...': 'Khusus...',
  'Custom color': 'Warna khusus',
  'No color': 'Tanpa berwarna',
  'Remove color': 'Hapus warna',
  'Show blocks': 'Tampilkan blok',
  'Show invisible characters': 'Tampilkan karakter tak tampak',
  'Word count': 'Hitungan kata',
  Count: 'Hitungan',
  Document: 'Dokumen',
  Selection: 'Pemilihan',
  Words: 'Kata',
  'Words: {0}': 'Kata: {0}',
  '{0} words': '{0} kata',
  File: 'Berkas',
  Edit: 'Edit',
  Insert: 'Masukkan',
  View: 'Tampilkan',
  Format: 'Format',
  Table: 'Tabel',
  Tools: 'Alat',
  'Powered by {0}': 'Didayai oleh {0}',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help': 'Area Teks Kaya. Tekan ALT-F9 untuk menu. Tekan ALT-F10 untuk bilah alat. Tekan ALT-0 untuk bantuan',
  'Image title': 'Judul gambar',
  'Border width': 'Lebar pinggiran',
  'Border style': 'Gaya pinggiran',
  Error: 'Kesalahan',
  Warn: 'Peringatkan',
  Valid: 'Valid',
  'To open the popup, press Shift+Enter': 'Untuk membuka popup, tekan Shift+Enter',
  'Rich Text Area': 'Area Rich Text',
  'Rich Text Area. Press ALT-0 for help.': 'Area Teks Kaya. Tekan ALT-0 untuk bantuan.',
  'System Font': 'Huruf Sistem',
  'Failed to upload image: {0}': 'Gagal mengunggah gambar: {0}',
  'Failed to load plugin: {0} from url {1}': 'Gagal memuat plugin: {0} dari url {1}',
  'Failed to load plugin url: {0}': 'Gagal memuat url plugin: {0}',
  'Failed to initialize plugin: {0}': 'Gagal memulai plugin: {0}',
  example: 'contoh',
  Search: 'Cari',
  All: 'Semua',
  Currency: 'Mata Uang',
  Text: 'Teks',
  Quotations: 'Kutipan',
  Mathematical: 'Matematis',
  'Extended Latin': 'Latin Diperluas',
  Symbols: 'Simbol',
  Arrows: 'Panah',
  'User Defined': 'Ditentukan Pengguna',
  'dollar sign': 'tanda dolar',
  'currency sign': 'tanda mata uang',
  'euro-currency sign': 'tanda mata uang eropa',
  'colon sign': 'tanda titik dua',
  'cruzeiro sign': 'tanda cruzeiro',
  'french franc sign': 'tanda franc prancis',
  'lira sign': 'tanda lira',
  'mill sign': 'tanda mill',
  'naira sign': 'tanda naira',
  'peseta sign': 'tanda peseta',
  'rupee sign': 'tanda rupee',
  'won sign': 'tanda won',
  'new sheqel sign': 'tanda sheqel baru',
  'dong sign': 'tanda dong',
  'kip sign': 'tanda kip',
  'tugrik sign': 'tanda tugrik',
  'drachma sign': 'tanda drachma',
  'german penny symbol': 'simbol penny jerman',
  'peso sign': 'tanda peso',
  'guarani sign': 'tanda guarani',
  'austral sign': 'tanda austral',
  'hryvnia sign': 'tanda hryvnia',
  'cedi sign': 'tanda cedi',
  'livre tournois sign': 'tanda livre tournois',
  'spesmilo sign': 'tanda spesmilo',
  'tenge sign': 'tanda tenge',
  'indian rupee sign': 'tanda rupee india',
  'turkish lira sign': 'tanda lira turki',
  'nordic mark sign': 'tanda mark nordik',
  'manat sign': 'tanda manat',
  'ruble sign': 'tanda ruble',
  'yen character': 'karakter yen',
  'yuan character': 'karakter yuan',
  'yuan character, in hong kong and taiwan': 'karakter yuan, di hong kong dan taiwan',
  'yen/yuan character variant one': 'varian satu karakter yen/yuan',
  Emojis: 'Emoji',
  'Emojis...': 'Emoji...',
  'Loading emojis...': 'Memuat emoji...',
  'Could not load emojis': 'Tidak dapat memuat emoji',
  People: 'Orang',
  'Animals and Nature': 'Hewan dan Alam',
  'Food and Drink': 'Makanan dan Minuman',
  Activity: 'Aktivitas',
  'Travel and Places': 'Perjalanan dan Lokasi',
  Objects: 'Objek',
  Flags: 'Bendera',
  Characters: 'Karakter',
  'Characters (no spaces)': 'Karakter (tanpa spasi)',
  '{0} characters': '{0} karakter',
  'Error: Form submit field collision.': 'Kesalahan: Benturan bidang pengiriman bentuk.',
  'Error: No form element found.': 'Kesalahan: tidak ditemukan elemen bentuk.',
  'Color swatch': 'Contoh warna',
  'Color Picker': 'Pemilih warna',
  'Invalid hex color code: {0}': 'Kode warna hex tidak valid: {0}',
  'Invalid input': 'Masukan tidak valid',
  R: 'R',
  'Red component': 'Komponen merah',
  G: 'G',
  'Green component': 'Komponen hijau',
  B: 'B',
  'Blue component': 'Komponen biru',
  '#': '#',
  'Hex color code': 'Kode warna hex',
  'Range 0 to 255': 'Rentang 0 hingga 255',
  Turquoise: 'Toska',
  Green: 'Hijau',
  Blue: 'Biru',
  Purple: 'Ungu',
  'Navy Blue': 'Biru Navy',
  'Dark Turquoise': 'Turquoise Gelap',
  'Dark Green': 'Hijau Gelap',
  'Medium Blue': 'Biru Medium',
  'Medium Purple': 'Ungu Medium',
  'Midnight Blue': 'Biru Midnight',
  Yellow: 'Kuning',
  Orange: 'Jingga',
  Red: 'Merah',
  'Light Gray': 'Abu Muda',
  Gray: 'Abu-abu',
  'Dark Yellow': 'Kuning Gelap',
  'Dark Orange': 'Jingga Gelap',
  'Dark Red': 'Merah Gelap',
  'Medium Gray': 'Abu Medium',
  'Dark Gray': 'Abu Gelap',
  'Light Green': 'Hijau Muda',
  'Light Yellow': 'Kuning Muda',
  'Light Red': 'Merah Muda',
  'Light Purple': 'Ungu Muda',
  'Light Blue': 'Biru Muda',
  'Dark Purple': 'Ungu Gelap',
  'Dark Blue': 'Biru Gelap',
  Black: 'Hitam',
  White: 'Putih',
  'Switch to or from fullscreen mode': 'Alihkan ke atau dari mode layar penuh',
  'Open help dialog': 'Buka dialog bantuan',
  history: 'riwayat',
  styles: 'gaya',
  formatting: 'pemformatan',
  alignment: 'penyejajaran',
  indentation: 'indentasi',
  Font: 'Huruf',
  Size: 'Ukuran',
  'More...': 'Lainnya...',
  'Select...': 'Pilih...',
  Preferences: 'Preferensi',
  Yes: 'Ya',
  No: 'Tidak',
  'Keyboard Navigation': 'Navigasi Keyboard',
  Version: 'Versi',
  'Code view': 'Tampilan Kode',
  'Open popup menu for split buttons': 'Buka menu popup untuk tombol terpisah',
  'List Properties': 'Daftar properti',
  'List properties...': 'Daftar properti...',
  'Start list at number': 'Mulai daftar dari nomor',
  'Line height': 'Tinggi baris',
  'Dropped file type is not supported': 'Jenis file yang dijatuhkan tidak didukung',
  'Loading...': 'Memuat...',
  'ImageProxy HTTP error: Rejected request': 'Kesalahan HTTP ImageProxy: Permintaan ditolak',
  'ImageProxy HTTP error: Could not find Image Proxy': 'Kesalahan HTTP ImageProxy: Tidak dapat menemukan Proxy Gambar',
  'ImageProxy HTTP error: Incorrect Image Proxy URL': 'Kesalahan HTTP ImageProxy: URL Proxy Gambar Salah',
  'ImageProxy HTTP error: Unknown ImageProxy error': 'Kesalahan HTTP ImageProxy: Kesalahan Proxy Gambar tidak diketahui'
});